<template>
  <div>
    <v-data-table
      id="data-table-items-sasonalidades"
      v-model="itemSelecionado"
      :headers="headers"
      :items="desserts"
      :items-per-page="-1"
      :search="search"
      :fixed-header="true"
      item-key="idproduto"
      show-expand
      show-select
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      @item-expanded="getDadosExpanded"
      :height="expanded.length > 0 ? 'calc(100vh - 130px)' : 'calc(100vh - 180px)'"
      class="font-resp-tabela table-full-screen"
      :hide-default-footer="expanded.length > 0"
    >
      <template slot="top">
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n2">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            <span class="subtitle-1 font-weight-bold">Lista de Produtos Sazonais</span>
          </v-toolbar-title>

          <v-divider class="mx-5" inset vertical></v-divider>

          <v-badge color="white" overlap v-if="itemSelecionado.length > 0">
            <template v-slot:badge>
              <span
                class="font-weight-medium"
                style="color: #000"
              >
                {{ itemSelecionado.length }}
              </span>
            </template>

            <v-btn small color="red" dark @click="dialogDeletarMultiplaSazonalidade()">
              <v-icon left>mdi-delete</v-icon>
              excluir
            </v-btn>
          </v-badge>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-5 mt-n1"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            clearable
            hide-details
            style="max-width: 450px"
          ></v-text-field>

          <!-- <novo-produto-sazonal
            :editedItem="editedItem"
            :countDesserts="countDesserts"
            :itemSelecionado="itemSelecionado"
            :openDialogNovaSazonalidade="openDialogNovaSazonalidade"
            @atualizar-data-table="initialize(); itemSelecionado = []"
            @limpar-edited-item="editedItem = null"
          ></novo-produto-sazonal> -->
          <CadastroProdutoSazonal
            :editedItem="editedItem"
            :countDesserts="countDesserts"
            :itemSelecionado="itemSelecionado"
            :openDialogNovaSazonalidade="openDialogNovaSazonalidade"
            @atualizar-data-table="initialize(); itemSelecionado = []"
            @limpar-edited-item="editedItem = null"
            @fechar-dialog-nova-sazonalidade="openDialogNovaSazonalidade = false; $emit('fechar-dialog-nova-sazonalidade')"
          />

          <CadastroProdutoPeriodoSazonal
            :dialog="dialog_periodo"
            :editedItem="editedItem"
            @atualizar-data-table="initialize(); itemSelecionado = []"
            @fechar-dialog-editando="dialog_periodo = false; editedItem = []"
          />
        </v-toolbar>
      </template>

      <template v-slot:item.dia_mes_inicial="{ item }">
        <span v-if="item.dia_mes_inicial">
          <span v-for="(dado, idx_inicial) in item.dia_mes_inicial.split(',')" :key="idx_inicial">
            <p class="pa-0 ma-0">{{ dado }}</p>
          </span>
        </span>
      </template>

      <template v-slot:item.dia_mes_final="{ item }">
        <span v-if="item.dia_mes_final">
          <span v-for="(dado, idx_final) in item.dia_mes_final.split(',')" :key="idx_final">
            <p class="pa-0 ma-0">{{ dado }}</p>
          </span>
        </span>
      </template>

      <template v-slot:item.tempo_medio_ressuprimento="{ item }">
        {{ Helpers.formatarValorComCasas(item.tempo_medio_ressuprimento, 2) }}
      </template>

      <template v-slot:item.media_crescimento="{ item }">
        {{ Helpers.formatarValorComCasas(item.media_crescimento, 2) }}
      </template>

      <template v-slot:item.media_anterior="{ item }">
        {{ Helpers.formatarValorComCasas(item.media_anterior, 2) }}
      </template>

      <template v-slot:item.porcentagem="{ item }">
        {{ Helpers.formatarValorComCasas(item.porcentagem, 2) + '%' }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-btn icon @click="editarSazonalidade(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon @click="dialogDeletarSazonalidade(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length">
          <p class="ma-0 subtitle-1 font-weight-medium my-1">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Produto por Filial
          </p>

          <v-divider></v-divider>

          <produto-sazonal
            :produto="dessertsExpanded"
            @editar-sazonalidade-produto-filial="editarSazonalidadeFilial($event)"
          ></produto-sazonal>
        </td>
      </template>
    </v-data-table>

    <dialog-confirmacao
      title="Exclusão"
      :dialog="dialogConfirmacao"
      :messages="excluirSazonalidade.mensagemExclusao"
      width-body="450px"
      color="red"
      icon="mdi-delete"
      @confirmado="excluirSazonalidadeProdutos()"
      @change-dialog="dialogConfirmacao = false"
    >
      <template #body>
        <p class="ma-0 mb-4">
          Deseja realmente excluir
          {{
            (itemSelecionado && itemSelecionado.length > 1)
            ? `os ${itemSelecionado.length} itens selecionados`
            : `o item selecionado`
          }}?
        </p>
      </template>
    </dialog-confirmacao>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from "vuex";
  import SazonalidadeAPI from "../../../api/sazonalidade";
  import NovoProdutoSazonal from "./NovoProdutoSazonal.vue";
  import CadastroProdutoSazonal from "./cadastro/CadastroProdutoSazonal.vue";
  import CadastroProdutoPeriodoSazonal from "./cadastro/CadastroProdutoPeriodoSazonal.vue";
  import ProdutoSazonal from './ProdutoSazonal.vue';
  import DialogConfirmacao from "../../utils/DialogConfirmacao.vue";

  export default {
    components: {
      NovoProdutoSazonal,
      ProdutoSazonal,
      DialogConfirmacao,
      CadastroProdutoSazonal,
      CadastroProdutoPeriodoSazonal
    },

    props: {
      dialogSazonalidade: {
        type: Boolean,
        default: false
      },
      open_dialog_nova_sazonalidade: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        singleExpand: true,
        expanded: [],
        search: '',
        headers: [
          { text: 'Fornecedor', value: 'fornecedor' },
          { text: 'Id Produto', value: 'idproduto' },
          { text: 'Descrição', value: 'descricao_produto' },
          { text: 'Dia/Mês Inicial', value: 'dia_mes_inicial' },
          { text: 'Dia/Mês Final', value: 'dia_mes_final' },
          { text: 'Recorrência', value: 'recorrencia_formatada' },
          { text: 'Média Anterior', value: 'media_anterior' },
          { text: 'Porcentagem', value: 'porcentagem' },
          { text: 'Média Aplicada', value: 'media_crescimento' },
          { text: 'Opções', value: 'actions' }
        ],
        desserts: [],
        dessertsSecond: [],
        dessertsExpanded: [],
        editedItem: [],
        countDesserts: {},
        openDialogNovaSazonalidade: false,
        dialogConfirmacao: false,
        excluirSazonalidade: {
          mensagemExclusao: [],
          produtos: []
        },
        itemSelecionado: [],
        selectedMulti: false,
        dialog_periodo: false
      }
    },

    mounted() {
      this.initialize();
      if (this.$route.path != '/produtos/sazonalidades') {
        this.openDialogNovaSazonalidade = this.open_dialog_nova_sazonalidade;
      }
    },

    watch: {
      dialogSazonalidade(valor) {
        if (valor) {
          this.initialize();
        } else {
          this.itemSelecionado = [];
        }
      },

      open_dialog_nova_sazonalidade(valor) {
        this.openDialogNovaSazonalidade = valor;
      },

      grupo_id() {
        this.initialize();
      }
    },

    computed: {
      ...mapGetters({
        grupo_id: "usuario/getGrupoCompras",
        getFornecedor: "fornecedor/getFornecedor",
        produtosSeleciondosVuex: "ProdutosSelecionados/getProdutosSelecionados",
        qtdeProdutosSeleciondosVuex: "ProdutosSelecionados/getQtdeProdutosSelecionados",
      }),
    },

    methods: {
      ...mapMutations({
        resetProdutosSelecionados: "ProdutosSelecionados/SET_RESET_PRODUTOS_SELECIONADOS",
        fecharDialogSazonalidade: "tabelaProduto/SET_FECHAR_DIALOG_SAZONALIDADE"
      }),

      initialize() {
        this.search = this.getFornecedor.razao_social && this.$route.name === 'Compra' ? this.getFornecedor.razao_social.trim() : '';
        this.expanded = [];
        let prods_id = [];

        // if (this.qtdeProdutosSeleciondosVuex > 0 && this.$route.path != '/produtos/sazonalidades') {
        //   prods_id = this.produtosSeleciondosVuex.map(function (el) { return el.idproduto });
        // }

        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          grupo_id: this.grupo_id,
          produto: prods_id
        };

        this.$store.dispatch("loadingAux/habilitarLoading", true);
        SazonalidadeAPI.getSazonalidades(headers, params)
          .then((response) => {
            const { token, sazonalidades } = response.data;
            localStorage.setItem("token", token);

            this.desserts = sazonalidades;
            this.countDesserts = {
              count: this.desserts.length,
              dados: this.desserts
            };
            this.$store.dispatch("loadingAux/habilitarLoading", false);
          })
          .catch(() => {
            this.$store.dispatch("loadingAux/habilitarLoading", false);
            this.Helpers.logout();
          });
      },

      editarSazonalidade(item) {
        this.dialog_periodo = true;
        this.editedItem = item;
      },

      editarSazonalidadeFilial(evento) {
        this.editedItem = evento;
      },

      dialogDeletarSazonalidade(item) {
        this.dialogConfirmacao = true;

        let prod = item.idproduto + ' - ' + item.descricao_produto;

        this.excluirSazonalidade.mensagemExclusao = [prod];

        this.excluirSazonalidade.produtos = [item];

        this.selectedMulti = false;
      },

      dialogDeletarMultiplaSazonalidade() {
        this.dialogConfirmacao = true;

        this.excluirSazonalidade.mensagemExclusao = [
          'Deseja realmente excluir a sazonalidade dos produtos a seguir:'
        ];
        this.itemSelecionado.forEach(el => {
          this.excluirSazonalidade.mensagemExclusao.push(el.idproduto + ' - ' + el.descricao_produto);
        });

        this.selectedMulti = true;
      },

      excluirSazonalidadeProdutos() {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.selectedMulti ? this.itemSelecionado : this.excluirSazonalidade.produtos;

        this.$store.dispatch("loading/addRequisicao",
          SazonalidadeAPI.excluirSazonalidadeProdutos(headers, params)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);

              this.itemSelecionado = [];
              this.initialize();
              this.resetProdutosSelecionados();
              this.fecharDialogSazonalidade();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        )
      },

      getDadosExpanded(dado) {
        if (dado.value == true) {
          this.dessertsSecond = this.desserts;
          this.desserts = [dado.item];
        } else {
          this.desserts = this.dessertsSecond;
        }

        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          idproduto: dado.item.idproduto,
          grupo_id: this.grupo_id
        }

        this.$store.dispatch("loading/addRequisicao",
          SazonalidadeAPI.getDadosExpanded(headers, params)
            .then((response) => {
              const { token, dados_expanded } = response.data;
              localStorage.setItem("token", token);

              this.dessertsExpanded = dados_expanded;
            })
            .catch(() => {
              this.Helpers.logout();
            })
        )
      }
    }
  }
</script>

<style>
#data-table-items-sasonalidades .v-data-table__wrapper table tbody tr td  {
  font-size: 12px;
  padding: 1px 5px 1px 5px;
}
#data-table-items-sasonalidades .v-data-table__wrapper table thead tr th  {
  font-size: 12px;
  padding: 0 4px 0 4px;
}
</style>
